import {TransactionColKey} from "../../../enums/TransactionColKey";

export const transactionColumnSortable = [
    TransactionColKey.number,
    TransactionColKey.date,
    TransactionColKey.contact_name,
    TransactionColKey.contact2_name,
    TransactionColKey.contact2_name,
    TransactionColKey.number2,
    TransactionColKey.title,
    TransactionColKey.description,
    TransactionColKey.amount,
    TransactionColKey.balance,
    TransactionColKey.overpayment,
    TransactionColKey.custom_fields, // multi-columns
    TransactionColKey.created_at,
];
